<div class="modelContainer alignCenter">  
  <div *ngIf="isLoader" class="svg-loader"></div>
  <div class="">
    <button (click)="onCancelClick()" type="button" class="close cancelBtn" typeof="button" aria-label="Close" mat-dialog-close>
      Close
    </button>
  </div>
  <div class="modelTitle">
    {{modelTitle}}
  </div>

  <div class="formulaBuilderDialogBody modelBody pl-4 pr-4">
    <form [formGroup]="formulaBuilderForm">
      <div class="row mb-3 px-5">
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6">
              <label for="frequency" class="">Frequency (mins) *</label>
            </div>
            <div class="col-md-6">
              <input type="number" class="form-control fbControlFrequency" name="frequency" formControlName="frequencyHcf" required />
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <div class="row">
            <div class="col-md-8">
              <label class="" for="siConversion">Ignore SI Conversion</label>
            </div>
            <div class="col-md-4">
              <label name="siConversion" class="switch" for="siConversion">
                <input id="siConversion" formControlName="siConversionIgnored" type="checkbox">
                <span class="slider round"></span>.
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
      <div class="row mb-3 px-5">
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6">
              <label class="" for="uomType">UOM Type *</label>
            </div>
            <div class="col-md-6">
              <select class="form-control" name="uomType" formControlName="uomType"
            (change)="populateUOM()" required>
            <option value="">--Select--</option>
            <option *ngFor="let uomType of uomTypes" [ngValue]="uomType">{{uomType}}</option>
          </select>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <div class="row">
            <div class="col-md-5">
              <label class="" for="uom">UOM *</label>
            </div>
            <div class="col-md-7">
              <select class="form-control" name="uom" formControlName="uom" required>
                <option value="">--Select--</option>
                <option *ngFor="let uom of uoms" [ngValue]="uom">{{uom}}</option>
              </select>
            </div>
          </div>          
        </div>
        <div class="col-md-3"></div>
      </div>
      <div class="paddingClassMainContent mb-3 px-5">
        <div class="row mainContent">
          <div class="col-md-3 tblFormulaNamesCol">
            <table id="tblFormulaNames" aria-labelledby ="Formula List">
              <thead>
                <tr>
                  <th>
                    Formula Name
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let formula of formulaList;let i= index">
                  <td id="fieldFormula_{{i}}"
                    [ngClass]="(formulaList.length-1==i)?'trFormulaName highlighted':'trFormulaName'"
                    (click)="traverseToAnotherFormula(i)">
                    <img *ngIf="formula.storageRequired" class="imgIntFormula" title="Intermediate Formula"
                      src="../../../assets/svg/Tooltip.svg" alt="intermediate formula" />
                    {{formula.formulaName}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="formFormulaMain col-md-9">
            <div class="row mb-3">
              <div class="col-2 pr-0">
                <label for="formulaName" class="">Formula Name *</label>
              </div>
              <div class="col-4">
                <label htmlFor= "formulaName" *ngIf="data.UsedFor === 'edit'" class="form-control fbControlFormulaName"
                name="formulaName">{{formulaBuilderForm.get('formulaName').value}}</label>
                <input *ngIf="data.UsedFor === 'view'||data.UsedFor === 'create'" type="text"
                  class="form-control fbControlFormulaName" name="formulaName" formControlName="formulaName" required />
              </div>
              <div class="col-2">
                <label *ngIf="data.UsedFor !== 'view'" for="dataSource" class="">Data Source</label>
              </div>
              <div class="col-4">
                <select *ngIf="data.UsedFor !== 'view'" class="form-control fbControlFormulaName" name="dataSource"
                formControlName="dataSource">
                <option *ngFor="let item of dataSources" [ngValue]="item">{{item.name}}</option>
              </select>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="expression" class="">Expression *</label>
              </div>
              <div class="col-10">
                <div class="form-control FormulaExpression fbLabelControlFormulaExpression customAutocomplete" [ngClass]="data.UsedFor === 'view'?'FormulaExpression FormulaExpressionView': 'FormulaExpression'">
                  <textarea placeholder="Type @ to search tags, $ for formulas, # for constants and ~ for math functions" 
                    type="text"
                    class="mb-3"
                    name="expression" 
                    formControlName="formulaExpression" 
                    [triggerCharacter]="shortcutKey"
                    (keypress)="checkShortcut($event)" 
                    [findChoices]="findChoices" 
                    id="txtAreaExpression" 
                    [mentionConfig]="expressionItems" 
                    (itemSelected)="itemSelected($event)" 
                    contenteditable="true"
                    #txtExpression>
                  </textarea>
                  <div *ngIf="data.UsedFor !== 'view'" class="info">Use the prefix &#64; for tags, $ for formulas, # for constants and ~ for math functions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {{formulaBuilderForm.errors}}
      <div class="d-flex justify-content-center">
        <button *ngIf="!storageRequired && data.UsedFor === 'edit'" class="btn btn-primary btnSaveInt mx-2"
          [disabled]="!formulaBuilderForm.valid" (click)="addNewFormula('edit')">Add an Intermediate</button>
        <button *ngIf="!storageRequired && data.UsedFor === 'create'" class="btn btn-primary btnSaveInt mx-2"
          [disabled]="!formulaBuilderForm.valid" (click)="saveIntermediate()">Save as Intermediate</button>
        <button type="submit" *ngIf="!storageRequired && data.UsedFor !== 'view'" class="btn btn-primary btnSave mx-2"
          [disabled]="!formulaBuilderForm.valid" (click)="SaveFormula()">Save</button>
        <button *ngIf="storageRequired && data.UsedFor !== 'view'" class="btn btn-primary btnDelete mx-2"
          (click)="deleteIntermediate()">Delete</button>
      </div>
    </form>
  </div>
</div>